  
<nz-spin [nzSpinning]="loading" nzTip="Carregando depara...">
  <mat-dialog-content class="custom-dialog-container form-field-density-4">
  <!--div class="spinner-container" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div-->
  
    <div *ngIf="!loading" class="form-field-density-4">
      <h2>Configuração D-PARA para {{data.instanceName}}</h2>
      <div class="header-config">
        <div class="header-config-left">
          <div *ngIf="!isJSON">
            <mat-checkbox [(ngModel)]="hasHeader">CSV possui cabeçalho?</mat-checkbox>
          </div>
          <div>
            <mat-checkbox [(ngModel)]="hasUpdate">Atualizar tabela com registro importado?</mat-checkbox>
          </div>
          <div>
            <mat-checkbox [(ngModel)]="multiCompany">Permite importar múltiplas empresas?</mat-checkbox>
          </div>
          <!--div>
            <mat-checkbox [(ngModel)]="isJSON">Importação de JSON por Endpoint</mat-checkbox>
          </div-->
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div class="header-config-right">
          <div *ngIf="isJSON" class="form-field-density-4">
            <mat-form-field class="example-full-width">
              <mat-label>Endpoint:</mat-label>
              <input matInput class="marginLeft endpoint" [(ngModel)]="url">
            </mat-form-field>
          </div>
          <div *ngIf="isJSON" class="tokenForm form-field-density-4">
            <mat-form-field class="example-full-width">
              <mat-label>Token:</mat-label>
              <input matInput class="marginLeft endpoint token" [(ngModel)]="token">
            </mat-form-field>
            <button mat-raised-button color="primary" (click)="loadJsonFromEndpoint()" class="load-json-button">Buscar Informações</button>
          </div>    
          <mat-form-field class="example-full-width" *ngIf="!isJSON">
            <mat-label>Número da linha do cabeçalho:</mat-label>
            <input matInput class="marginLeft" [(ngModel)]="headerLineNumber">
          </mat-form-field>
        </div>
        
      </div>
      <div class="table-container">
        <table mat-table  [dataSource]="columns" class="mat-elevation-z8" *ngIf="!isJSON">
        
          <ng-container matColumnDef="desc">
            <th mat-header-cell *matHeaderCellDef> Descrição </th>
            <td mat-cell *matCellDef="let column" class="cell-align-center"> {{column.COLUMNDESC}} </td>
          </ng-container>
    
          <ng-container matColumnDef="field">
            <th mat-header-cell *matHeaderCellDef> Campo </th>
            <td mat-cell *matCellDef="let column" class="cell-align-center"> {{column.COLUMNNAME}} </td>
          </ng-container>
    
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef> Tipo de Dado </th>
            <td mat-cell *matCellDef="let column" class="cell-align-center">  {{column.DATATYPE}} ( {{column.COLSIZE}} )</td>
          </ng-container>
      
          <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef> PK  </th>
            <td mat-cell *matCellDef="let column" class="cell-align-center"> 
              <span *ngIf="column.ISPK === 1">Sim</span>
              <span *ngIf="column.ISPK === 2">-</span>
              <span *ngIf="column.ISPK === 0">-</span>
            </td>
          </ng-container>
    
      
          
          <ng-container matColumnDef="dpara">
            <th mat-header-cell *matHeaderCellDef> D-PARA </th>
            <td mat-cell *matCellDef="let column" class="cell-align-center">
                <mat-form-field appearance="outline" class="compact-field">            
                    <input matInput [(ngModel)]="column.dparaValue">
                </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="df">
            <th mat-header-cell *matHeaderCellDef>Fórmula</th>
            <td mat-cell *matCellDef="let column" class="cell-align-center">
                <mat-form-field appearance="outline" class="compact-field formula-field">            
                    <input matInput [(ngModel)]="column.formula">
                    <button mat-icon-button matSuffix (click)="openEditFormula(column)" type="button">
                      <mat-icon>more_vert</mat-icon>
                    </button>                    
                </mat-form-field>
            </td>
        </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="warn" mat-dialog-close>CANCELAR</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="{
      columns: columns,
      hasHeader: hasHeader,
      hasUpdate: hasUpdate,
      multiCompany: multiCompany,
      headerLineNumber: headerLineNumber
    }" cdkFocusInitial>OK</button>
  </mat-dialog-actions>
</nz-spin>

